import styled from 'styled-components';

export const FlexContainer = styled.div`
  position: ${({ position }) => position};
  display: flex;
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  height: ${({ height }) => height};
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};
  flex-wrap: ${({ flexWrap }) => (flexWrap ? 'wrap' : 'nowrap')};
  flex-grow: ${({ flexGrow }) => (flexGrow ? 1 : 'initial')};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  cursor: ${({ cursor }) => cursor};
  @media only screen and (max-width: 1157px) {
    width: ${({ tabletWidth }) => tabletWidth};
    padding: ${({ tabletPadding }) => tabletPadding};
    flex-direction: ${({ tabletFlexDirection }) => tabletFlexDirection};
    justify-content: ${({ tabletJustifyContent }) => tabletJustifyContent};
    align-items: ${({ tabletAlignItems }) => tabletAlignItems};
    margin: ${({ tabletMargin }) => tabletMargin};
    height: ${({ tabletHeight }) => tabletHeight};
    flex-wrap: ${({ tabletFlexWrap }) => (tabletFlexWrap ? 'wrap' : 'nowrap')};
    display: ${({ tabletDisplay }) => tabletDisplay};
  }

  @media only screen and (max-width: 568px) {
    width: ${({ mobileWidth }) => mobileWidth};
    height: ${({ mobileHeight }) => mobileHeight};
    padding: ${({ mobilePadding }) => mobilePadding};
    margin: ${({ mobileMargin }) => mobileMargin};
    flex-direction: ${({ mobileFlexDirection }) => mobileFlexDirection};
    justify-content: ${({ mobileJustifyContent }) => mobileJustifyContent};
    align-items: ${({ mobileAlignItems }) => mobileAlignItems};
    display: ${({ mobileDisplay }) => mobileDisplay};
    flex-wrap: ${({ mobileFlexWrap }) => (mobileFlexWrap ? 'wrap' : 'nowrap')};
  }
`;

export const FlexItem = styled.div`
  flex: ${({ flex }) => flex};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  width: ${({ width }) => width};
  cursor: ${({ cursor }) => cursor};

  @media only screen and (max-width: 1157px) {
    width: ${({ tabletWidth }) => tabletWidth};
    padding: ${({ tabletPadding }) => tabletPadding};
    flex-direction: ${({ tabletFlexDirection }) => tabletFlexDirection};
    justify-content: ${({ tabletJustifyContent }) => tabletJustifyContent};
    align-items: ${({ tabletAlignItems }) => tabletAlignItems};
    margin: ${({ tabletMargin }) => tabletMargin};
  }

  @media only screen and (max-width: 568px) {
    width: ${({ mobileWidth }) => mobileWidth};
    padding: ${({ mobilePadding }) => mobilePadding};
    flex-direction: ${({ mobileFlexDirection }) => mobileFlexDirection};
    justify-content: ${({ mobileJustifyContent }) => mobileJustifyContent};
    margin: ${({ mobileMargin }) => mobileMargin};
    display: ${({ mobileDisplay }) => mobileDisplay};
    margin: ${({ mobileMargin }) => mobileMargin || 0};
  }
`;
